import type { ComponentPropsWithoutRef } from "react";
import classnames from "classnames";
import { defaultStyle } from "./defaultStyle";

export interface CustomButtonProps {
  children: React.ReactNode;
  isNext?: boolean;
  isPrevious?: boolean;
  isSelected?: boolean;
  properties: ComponentPropsWithoutRef<"button">;
}

export const CustomButton = ({
  isNext,
  isPrevious,
  isSelected,
  children,
  properties,
}: CustomButtonProps) => {
  const buttonClass = classnames(defaultStyle, {
    "border rounded-l-lg": isPrevious,
    "border rounded-r-lg": isNext,
    "border bg-secondary": isSelected,
  });

  return (
    <button type="submit" className={buttonClass} {...properties}>
      {children}
    </button>
  );
};
